<template>
    <div>
       <!-- <app-header-simple></app-header-simple>! -->
        <vue-custom-scrollbar class="scroll-area scroll-area--mb">
            <app-member-list
                v-for="(item, index) of students"
                :member="item"
                :key="index"
            ></app-member-list>
        </vue-custom-scrollbar>

        <router-view></router-view>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import LeftPanel from './LeftPanel.vue';
    // import RightPanel from './RightPanel.vue';
    import env from '../../env';
    import HeaderSimple from "../../common_components/HeaderSimple";
    import MemberList from "./MemberList";
    import vueCustomScrollbar from 'vue-custom-scrollbar';

    export default {
        data: () => ({
            env,
            blocker: false
        }),
        components: {
            appHeaderSimple: HeaderSimple,
            appLeftPanel: LeftPanel,
            appMemberList: MemberList,
            vueCustomScrollbar,
        },
        computed: {
            ...mapGetters([
                'loggedInHash',
                'loggedIn',
                'sidebarStateLeft',
                'sidebarStateRight',
                'userData',
                'students_payer'
            ]),
            students() {
                return this.students_payer && typeof this.students_payer === 'object' ? this.students_payer : false
            },
        },
        watch: {
            loggedInHash: function (val) {
                if(!this.loggedIn){
                    this.$router.push({ name: 'login' });
                }
            },
        },

    }
</script>

<style lang="sass" scoped>
    @import "../../../sass/cabinet"
    @import "../../../sass/teacherLesson"
    @import "../../../sass/teacherCheckwork"
    @import "../../../sass/studentStat"
    @import "../../../sass/teacherMaterials"

    .scroll-area
        padding: 20px 0
        margin-top: -20px
        position: relative
        height: calc(100vh - 72px)

        @media (max-width: 990px)
            height: calc(100vh - 143px)

        @media (max-width: 767px)
            height: calc(100vh - 206px)

</style>
